export default __webpack_public_path__ + "static/media/995.45787b8c.png";